import _ from "lodash";
import filter from "@/filter/filter.sub.js"
export default {
  name: "betweenPrice",
  data() {
    return {
      costListname: [{
          name: "折價",
          value: "discash"
        },
        {
          name: "折扣",
          value: "dispa"
        },
        {
          name: "指定",
          value: "setprice"
        }
      ],
      periodOpen: {
        method: "",
        opend: false
      },
      perioddata: {
        starttime: this.$moment(),
        throughtdate: 30,
        endtime: this.$moment().add(1, "months"),
        code: "",
        pre: "預購",
        name: "優惠第二波",
        price: {
          // discash ,  dispa ,setprice
          method: "discash",
          price: ""
        },
        remark: "",
        order: ""
      },
    }
  },
  computed: {
    getListname() {
      return (data, where) => {
        const st = filter.filter(data, where);
        return st[0].name;
      }
    },
    getperindStart: {
      get() {
        return new Date(this.perioddata.starttime.format("YYYY/MM/DD"));
      },
      set(data) {
        this.perioddata.starttime = this.$moment(data);
        this.perioddata.endtime = this.perioddata.starttime.clone().add(this.perioddata
          .throughtdate, "days");
      }
    },
    getthroughtdate: {
      get() {
        return this.perioddata.throughtdate;
      },
      set(data) {
        this.perioddata.endtime = this.perioddata.starttime.clone().add(data, "days");
      },
    },
  },
  methods: {
    changeT(name, value, parsent = "", node = "") {
      if (parsent) {
        if (node) {
          this[parsent][node][name] = value;
        } else {
          this[parsent][name] = value;
        }
      } else {
        this[name] = value;
      }
    },
    openperiod(method, data = {}) {
      this.periodOpen.open = true;
      this.periodOpen.method = method;
      if (method == "insert") {
        this.perioddata = {
          starttime: this.$moment(),
          throughtdate: 30,
          endtime: this.$moment().add(1, "months"),
          code: "",
          pre: "",
          name: "",
          price: {
            method: "discash",
            price: ""
          },
          remark: "",
          order: ""
        };

      } else if (method == "update") {
        this.perioddata = {
          starttime: this.$moment(data.startdate),
          throughtdate: this.$moment(data.enddate).diff(this.$moment(data.startdate), "days"),
          endtime: this.$moment(data.enddate),
          code: data.code,
          pre: data.pre,
          name: data.name,
          price: {
            method: data.price.method,
            price: data.price.price
          },
          remark: data.remark,
          uid: data.uid,
          order: data.order,
          sourcedata: data
        };
      }
    },
    periodOpenSave() {
      const tmps = _.clone(this.thdata.period);
      if (this.periodOpen.method == "update") {
        this.perioddata.sourcedata.code = this.perioddata.code;
        this.perioddata.sourcedata.pre = this.perioddata.pre;
        this.perioddata.sourcedata.name = this.perioddata.name;
        this.perioddata.sourcedata.startdate = this.perioddata.starttime;
        this.perioddata.sourcedata.enddate = this.perioddata.endtime;
        this.perioddata.sourcedata.remark = this.perioddata.remark;
        this.perioddata.sourcedata.order = this.perioddata.order;
        this.perioddata.sourcedata.online = "0";
        this.perioddata.sourcedata.price.method = this.perioddata.price.method;
        this.perioddata.sourcedata.price.price = this.perioddata.price.price;
      } else {
        this.thdata.period.push({
          code: this.perioddata.code,
          pre: this.perioddata.pre,
          name: this.perioddata.name,
          startdate: this.perioddata.starttime,
          enddate: this.perioddata.endtime,
          remark: this.perioddata.remark,
          order: this.perioddata.order,
          online: "0",
          price: {
            method: this.perioddata.price.method,
            price: this.perioddata.price.price
          },
          delete: 0
        });
      }
      this.periodOpenClose();
    },
    periodOpenClose() {
      this.perioddata = {
        starttime: this.$moment(),
        throughtdate: 30,
        endtime: this.$moment().add(1, "months"),
        code: "",
        pre: "",
        name: "",
        price: {
          method: "discash",
          price: ""
        },
        remark: "",
        order: ""
      }
    },
    deleteperiod(source) {
      this.$store.dispatch("Public/openConfirm", {
        title: "期間刪除",
        context: "確定要刪除「" + source.name + "」"
      }).then((data) => {
        console.log(data);
        if (data) {
          source.delete = 1;
        } else {

        }
      }).catch((error) => {});
    },
    saveperiod() {
        this.$emit("btnsave",this.perioddata);
    }
  },
  props: {
    baseData: {
      type: Object
    },
    thdata: Object,
    nosave: {
      type: Boolean,
      default: false
    },
  }
}
